<template>
    <div>
        <h2 class="q10__title" v-html="options.chapterTitle"></h2>
        <span class="q10__description" v-html="options.chapterDescription"></span>
    </div>
</template>

<script>
export default {
    name: "TitleAndDescription",
    props: {
        options: null,
    },
};
</script>

<style lang="scss" scoped>
.q10__title {
    @apply font-bold  xl:text-white;
    font-size: 5.5rem;
    line-height: 1;

    @media (max-width: 1536px) {
        font-size: 3.2rem;
        line-height: 1;
    }
    @media (max-width: 768px) {
        font-size: 2.2rem;
        line-height: 1;
        margin-bottom: 1rem;
    }
}

.q10__description {
    @apply text-sm 2xl:text-xl  xl:text-white;
}
</style>
